module.exports = __webpack_public_path__ + "img/jovem-pan.8616fe26.svg";